<template>
 <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
                Stati serie
        </h1>
        <b-tabs v-model="selectedTab">
            <b-tab-item label="Tabella">
              <div style="cursor:pointer">
              <b-table :data="rowData" :columns="columns"
                  :striped=true
                  :paginated="true"
                  :per-page="15"
                  :pagination-simple="false"
                  :selected.sync="selected"
                  @select="select"
                  @click="rowClicked"
                  >
                <b-input
                  slot="searchable"
                  slot-scope="props"
                  v-model="props.filters[props.column.field]"
                  placeholder="Cerca..."
                  icon="magnify"
                  size="is-small" 
                />
              </b-table>
              </div>
               <section>
                  <div class="buttons">
                    <b-button @click="doNew" type="is-primary" >Nuovo</b-button>
                  </div>
                </section>
            </b-tab-item>

            <b-tab-item label="Azioni" disabled>
            <div class="column is-half" ref="form">
                <section >
                  <span v-if="newItem.Id" class="subtitle">Id: {{newItem.Id}}</span>
                <b-field label="Stato">
                   <b-input ref="input1" v-model="newItem.SeriesStatus" required validation-message="Scrivi qualcosa!" ></b-input>
                </b-field>   
                
                <div class="field">
                  <b-checkbox v-model="newItem.Active">Attivo</b-checkbox>
                </div>
                                <div class="field">
                  <b-checkbox v-model="newItem.IsSeason">Per le stagioni?</b-checkbox>
                </div>
                </section>
                <section>
                  <div class="buttons">
                    <b-button @click="doEdit" type="is-primary" >Salva</b-button>
                    <b-button @click="doDelete" v-show="newItem.Id!=0" type="is-dark">Scancella</b-button>
                  </div>
                </section>
              </div>
            </b-tab-item>
          </b-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import api from "../api/api.js";
import helpers from "../helpers.js";

let emptyVal = {Id: 0, SeriesStatus:"" , Active:true, IsSeason: true};

export default {
  name: 'seriesStatus',
  methods: {
    doDelete() {
      this.$buefy.dialog.confirm({
        message: 'Lo scancello sul serio?',
        onConfirm: () => {
          const loading = this.$buefy.loading.open();
          api.seriesStatus.delete(this.newItem.Id) 
            .then (()=>{
              return api.seriesStatus.getAll()
            })
            .then ((rows)=>{
              this.rowData = rows.data;
              this.$store.state.modes = rows.data;
              helpers.ok('Stato correttamente scancellato');
              this.newItem = emptyVal;
              this.selectedTab = 0;
              loading.close();
            })
            .catch (()=> {
              helpers.error("PS: non è che ci sono serie con questa voce? Inattiva!");
              loading.close();
            })
        }
    })
    },
    doNew() {
      this.newItem = emptyVal;
      this.selectedTab = 1;
    },

    doEdit() {
      if(!this.$refs["input1"].checkHtml5Validity()) {
        return;
      }
      let apiMethod = this.newItem.Id!=0?api.seriesStatus.update:api.seriesStatus.create;
      const loading = this.$buefy.loading.open();
      apiMethod(this.newItem)
      .then (()=>{
        return api.seriesStatus.getAll() 
      })
      .then ((rows)=>{
          this.rowData = rows.data;
          this.$store.state.modes = rows.data;
          helpers.ok('Stato correttamente salvato');
          this.newItem = emptyVal;
          this.selectedTab = 0;
          loading.close();
      })
      .catch ((err)=> {
        helpers.error("Errore! " + err)
        loading.close();
      })
      
    },
    rowClicked(row) {
      if (row.Id==this.newItem.Id) {
         this.selected = null;
         this.newItem = emptyVal;
       }else {
         this.selectedTab=1;
       }
        
    },
    select(row) {
       this.newItem = row;
    }    
  },
  data() {
        return {
            selectedRow: null,
            newItem: emptyVal,
            rowData: [],
            selected: null,
            selectedTab: 0,
            columns: [
                {
                    field: 'Id',
                    label: 'id',
                    width: '40',
                    numeric: true
                },
                {
                    field: 'SeriesStatus',
                    label: 'Stato',searchable: true,
                    sortable: true
                },
                 {
                    field: 'Active',
                    label: 'Attivo',
                },
                {
                    field: 'IsSeason',
                    label: 'Solo Stagioni',
                }
            ]
        }
    },
    mounted() {
      const loading = this.$buefy.loading.open();
        api.seriesStatus.getAll()
        .then ((rows)=>{
          this.rowData = rows.data;
          this.$store.state.seriesStatuses = rows.data;
          loading.close();
        })
    }
}
</script>

<style>

</style>